import moment from 'moment';

angular.module('filters.daysAgo', [])
  .filter('daysAgo', function () {
    return function(date) {
      return moment(date, 'YYYYMMDD HH:mm:ssZ').fromNow();
    };
  });
